"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var events_1 = require("@shopify/javascript-utilities/events"); // see https://github.com/oliviertassinari/react-event-listener/


var EventListener =
/** @class */
function (_super) {
  tslib_1.__extends(EventListener, _super);

  function EventListener() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  EventListener.prototype.componentDidMount = function () {
    this.attachListener();
  };

  EventListener.prototype.componentDidUpdate = function (_a) {
    var passive = _a.passive,
        detachProps = tslib_1.__rest(_a, ["passive"]);

    this.detachListener(detachProps);
    this.attachListener();
  };

  EventListener.prototype.componentWillUnmount = function () {
    this.detachListener();
  };

  EventListener.prototype.render = function () {
    return null;
  };

  EventListener.prototype.attachListener = function () {
    var _a = this.props,
        event = _a.event,
        handler = _a.handler,
        capture = _a.capture,
        passive = _a.passive;
    events_1.addEventListener(window, event, handler, {
      capture: capture,
      passive: passive
    });
  };

  EventListener.prototype.detachListener = function (prevProps) {
    var _a = prevProps || this.props,
        event = _a.event,
        handler = _a.handler,
        capture = _a.capture;

    events_1.removeEventListener(window, event, handler, capture);
  };

  return EventListener;
}(React.PureComponent);

exports.EventListener = EventListener;